<template>
  <div class="articlepage-lists_wrapper">
     <home-nav :redirect="redirect">
          <div class="anchor-tab" slot="topbanner">
              <div class="tab-item">
                <img src="../assets/images/m_faq_questions_icon@3x.png" alt="常见问答">
                <div class="tab-text">常见问答</div>
              </div>
          </div>
      </home-nav>
      <div class="article-lists_wrapper" ref="wrapper" >
        <question-item :querstions="querstions"></question-item>
     </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import QuestionItem from '@/components/modules/QuestionItem';
import { Loadmore} from 'mint-ui';

export default {
  data(){
    return{
      articleLists:[],
      count:10,
      page:1,
      pages:0,
      slug:'article',
      floorScroll:"",
      pullup:true,
      pullingdown:false,
      loading:false,
      beforePullDown:true,
      allLoaded:false,
      norder:false,
      isPulling:false,
      isPullingDown:false,
      querstions:[
         {
          title:"我该选择哪个服务项目？",
          content:'比如您想恢复短信，请在果师兄App主页面菜单栏中选择【购买服务】，进入此页面后点击"短信"图标即可进入短信恢复流程，其他类似。'
        },
        {
          title:"我该选择哪个套餐？",
          content:"套餐有2种类型，分别是：预约排队，加急通道。您可以根据自身的数据的重要性，选择相应的服务套餐，因为数据丢失后往往需要第一时间找专业工程师恢复数据，否则数据可能损坏严重甚至找不回。"
        },
        {
          title:"预约人力费和数据恢复服务费有什么区别？",
          content:"恢复数据有两个重要步骤：数据恢复诊断分析和数据恢复，专业工程师对每一位预约的客户，都需要对设备和数据进行专业分析和判断，给出专业意见，这需要花费较高的人力成本；数据是无价的，数据能够被恢复是最好的，而如果工程师发现数据不能恢复将不会收取其他费用。因此，预约人力费是支付给果师兄工程师的数据分析诊断的人工费，而数据恢复服务费是支付成功恢复数据的功能费。"
        },
        {
          title:"我怎么付款？支持哪些付款方式？",
          content:"当前支持支付宝支付和微信支付，您在提交订单后可以很方便的进行付款，如果您不知道如何付款或者不会操作，可以咨询在线客服。"
        },
        {
          title:"我付款时，为什么需要我提供QQ号？",
          content:"因为专业工程师帮您恢复数据时，可能会需要远程协助，以及必要的语音沟通，QQ比较方便，是工程师助您快速恢复数据的较好沟通方式。"
        },
        {
          title:"我付款成功后，工程师什么时候联系我？",
          content:"您付款成功，就代表工单提交成功，工程师联系您的时间取决于您购买的工单套餐，具体区别是：在工作时间内（9-22点），预约排队是1小时内联系您；加急处理是10分钟内联系您。您需要及时注意您的QQ或者手机短信，以防错过工程师联系您。"
        },
         {
          title:"在果师兄App上没有找到我想要恢复的数据怎么办？",
          content:"您可以反馈您的诉求给【在线客服】或发送邮件到：lucy@auntec.com"
        },
      ],
      redirect:true,
    }
  },
  watch:{
   
  },
  methods:{
    getArticles(){
      var vm = this;
      let  info = {
        count:vm.count,
        page :vm.page,
        category_slug: vm.slug
      }
      this.$store.dispatch('getArticles',info).then((res)=>{
        const data = res.data;
        if(data.status == 'ok'){
          if(!vm.isPullingDown){
            vm.articleLists = [];
            vm.articleLists = data.posts;
          }else{
            vm.articleLists.push(...data.posts);
            vm.isPullingDown = false;
          }

          vm.pages = data.pages;
          if(vm.pages <= vm.page){
            vm.allLoaded = true;
          }
        }
      })
    },
    loadTop(){
      this.page = 1;
      this.getArticles();
      this.allLoaded = false;
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.$refs.loadmore.onTopLoaded();
        },400)
      })
    },
    loadBottom(){
      
      this.page = this.page+1;
      this.isPullingDown = true;
      this.getArticles();
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.$refs.loadmore.onBottomLoaded();
        },1000)
      })
       
    }
    
  },
  components:{
    QuestionItem,
    Loadmore
  },
  mounted(){
   
  },
  created(){
    this.getArticles();
 
  },
 
}
</script>

<style lang="scss">
@import '../assets/css/base.scss';

.articlepage-lists_wrapper{
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow-y: scroll;
  padding-bottom: 0.53333rem;
  z-index: 1;
}
.nomore{
  color:#4d4d4d;
  font-size: pxtorem(14px);
  text-align: center;
  padding:pxtorem(10px);
}
.article-lists{
  padding:pxtorem(10px) 0;
}
.anchor-tab{
      width:px2vw(355px);
      height:pxtorem(95px);
      margin:0 auto;
      background:rgba(255,255,255,0.95);
      box-shadow:0px 4px 5px -2px rgba(0,0,0,0.2);
      border-radius:pxtorem(6px);
      display: flex;
      justify-content: center;
      align-items: center;
      padding:0 px2vw(75px);
      box-sizing: border-box;
  }
  .tab-item{
    text-align: center;
    font-size:pxtorem(13px);
    color:rgba(89,89,89,1);
    cursor: pointer;
    img{
      width:pxtorem(42px);
      margin-bottom:pxtorem(8px);
    }
  }
  .pulldown{
    color:#4d4d4d;
    text-align: center;
    padding-bottom: pxtorem(10px);
    font-size: pxtorem(12px);
    position: absolute;
    top:pxtorem(-20px);
    left:50%;
    transform: translateX(-50%);
    z-index: 1111;

  }
</style>



// WEBPACK FOOTER //
// src/components/Ask.vue